<!-- <p>
  Parceiro:
  <input type="text" [(ngModel)]="partner">
  <a href="{{partner}}">Enviar</a>
</p> -->
<link rel="stylesheet" type="text/css" href="/assets/olaclick.css">
<div fxLayout="row" fxLayout.lt-md="column" class="layout flex-container" fxFlexFill [style.min-height]="'100vh'">
  <div class="logo-container" fxLayout="column">
    <svg xmlns="http://www.w3.org/2000/svg" width="183" height="237" fill="none" viewBox="0 0 183 237">
      <path fill="#31B34E"
        d="M97.893 67.456a3.533 3.533 0 00-3.5 3.55v8.205a3.532 3.532 0 003.5 3.545 3.527 3.527 0 003.5-3.545v-8.205a3.529 3.529 0 00-3.5-3.55m0 22.957a3.566 3.566 0 00-3.5 3.621v4.237a3.566 3.566 0 003.5 3.621 3.562 3.562 0 002.498-1.087 3.562 3.562 0 001.002-2.534v-4.237a3.562 3.562 0 00-1.002-2.534 3.562 3.562 0 00-2.498-1.087m0-62.493a3.556 3.556 0 00-3.5 3.6v24.04a3.56 3.56 0 003.5 3.6 3.557 3.557 0 003.5-3.6V31.52a3.555 3.555 0 00-3.5-3.6" />
      <path fill="#31B34E"
        d="M125.249 160.558h-70.18a3.61 3.61 0 11-.001-7.218h10.843v-48.6h-16.71c-2.525.004-5.025-.5-7.352-1.482a19.215 19.215 0 01-11.728-17.396V64.327a13.917 13.917 0 014.034-9.917 13.91 13.91 0 0115.235-3.048 13.924 13.924 0 018.563 12.965V76.74h7.957V24.892a24.241 24.241 0 017.103-17.147A24.255 24.255 0 0190.16.642a24.241 24.241 0 0117.147 7.103 24.241 24.241 0 017.103 17.147v36.23h8.79V35.933a13.927 13.927 0 018.564-12.964 13.91 13.91 0 0115.235 3.047 13.927 13.927 0 014.034 9.917v33.993a19.159 19.159 0 01-19.08 19.2h-17.546v64.214h10.842a3.609 3.609 0 110 7.218zM43.237 57.711a6.773 6.773 0 00-6.753 6.773v21.184a11.958 11.958 0 0011.925 11.959h21.162a3.603 3.603 0 013.581 3.32v52.393h34.2V85.187a3.6 3.6 0 013.592-3.6h21.162a11.954 11.954 0 0011.925-11.959V35.685a6.75 6.75 0 00-6.753-6.753 6.754 6.754 0 00-6.753 6.753v28.751a3.603 3.603 0 01-3.592 3.6h-15.99a3.602 3.602 0 01-3.593-3.6V24.661c0-2.246-.442-4.47-1.302-6.544A17.09 17.09 0 0090.25 7.561a17.085 17.085 0 00-12.091 5.009 17.089 17.089 0 00-5.009 12.091v56.1a3.597 3.597 0 01-3.582 3.321H53.581a3.598 3.598 0 01-3.592-3.6V64.484a6.77 6.77 0 00-6.752-6.773z" />
      <path fill="#000"
        d="M65.154 236.34c-10.49 0-15.807-5.35-15.807-15.9v-24.233a3.665 3.665 0 011.138-2.693 3.869 3.869 0 015.453 0 3.673 3.673 0 011.141 2.693v24.519c0 3.229.668 5.589 1.984 7.013 1.316 1.424 3.393 2.125 6.213 2.125 2.82 0 4.904-.715 6.204-2.124 1.316-1.426 1.983-3.785 1.983-7.013v-24.635a3.555 3.555 0 011.117-2.607 3.734 3.734 0 012.639-1.094 3.72 3.72 0 012.638 1.094 3.56 3.56 0 011.109 2.607v24.348c-.004 10.55-5.323 15.9-15.812 15.9zm-48.767-.578a3.718 3.718 0 01-2.7-1.094 3.615 3.615 0 01-1.107-2.664v-33.133H3.856a3.192 3.192 0 01-2.317-.95 3.113 3.113 0 01-.959-2.292 3.112 3.112 0 01.962-2.289 3.213 3.213 0 011.06-.712 3.203 3.203 0 011.256-.238h25.058a3.194 3.194 0 012.315.95 3.1 3.1 0 01.963 2.288 3.1 3.1 0 01-.963 2.288 3.193 3.193 0 01-2.315.95h-8.72v33.137a3.621 3.621 0 01-1.116 2.665 3.711 3.711 0 01-2.693 1.094zm163.181-.059h-.234a5.184 5.184 0 01-4.886-3.518l-2.36-7.7h-14.817a.237.237 0 00-.088.011l-2.336 7.674a4.76 4.76 0 01-1.823 2.553 5.135 5.135 0 01-3.068.979 2.89 2.89 0 01-2.432-1.22 2.753 2.753 0 01-.4-2.672l12.52-35.958a5.019 5.019 0 011.91-2.538 5.173 5.173 0 013.033-.974h.351a5.187 5.187 0 014.942 3.516l12.522 35.958a2.754 2.754 0 01-.4 2.669 2.891 2.891 0 01-2.434 1.22zm-14.923-35.169l-5.555 17.823h11.11l-5.555-17.823zm-37.949 35.169a5.724 5.724 0 01-5.183-3l-15.528-27.063v26.362a3.7 3.7 0 01-3.703 3.702 3.704 3.704 0 01-3.702-3.702V196.04a3.568 3.568 0 011.1-2.606 3.582 3.582 0 012.6-1.094 5.72 5.72 0 015.183 3l15.528 27.158V196.04a3.568 3.568 0 011.1-2.606 3.659 3.659 0 015.215 0 3.576 3.576 0 011.1 2.607v35.961a3.738 3.738 0 01-3.7 3.7l-.01.001z" />
    </svg>
  </div>
  <div fxFlex="50" fxLayout="column" fxFlex.lt-md="none" fxLayoutAlign="center center" class="background-logo">
    <app-footer fxFlex="none" fxLayout="row" fxLayoutAlign="center" class="footer">
      <div class="term" fxLayout="row">
        <a href="https://dev.tuna.uy/terms/" target="_blank">{{'enter.terms' | translate}}</a>
        <span>●</span>
        <a href="https://dev.tuna.uy/privacy/" target="_blank">{{'enter.privacy' | translate}}</a>
        <span>●</span>
        <a href="https://ajuda.tuna.uy/kb/?utm_source=console&utm_medium=user-menu&utm_campaign=root"
          target="_blank">{{'enter.helpcenter' | translate}}</a>
      </div>
    </app-footer>
  </div>

  <div class="content-container" fxFlex="100">
    <div class="content" fxFlex="100" fxFlex.lt-md="none" fxLayout="column">
      <div fxLayout="column" fxLayoutAlign="center start" class="info">
        <!-- BACK BUTTON -->
        <!-- <p class="back"> {{ 'enter.back' | translate }} </p> -->
        <p class="select-platform"> {{ 'enter.selectPlatform' | translate }} </p>
      </div>

      <div fxFlex.lt-md="100" fxLayout="row" fxLayoutAlign="center center" fxLayoutAlign.lt-md="center start"
        class="form">

        <mat-tab-group dynamicHeight fxFlex="100" fxLayout="column" fxLayoutAlign="center start" [selectedIndex]="selectedTab" (selectedIndexChange)="selectedTab = $event">
          <mat-tab label="MARKETPLACES">

            <div fxLayout="row wrap" fxLayoutAlign="start center" class="form-wrap">
              <div *ngFor="let partner of marketplacePartners">
                <button fxLayout="column" type="button" class="btn btn-outline-primary"
                  (click)="continueWithPartner(partner)" style="cursor: pointer;">
                  <div class="btn-img-container" fxFlex="100">
                    <img class="btn-img" src="/assets/images/marketing_places/logo-{{partner.img}}.svg"
                      alt="{{ partner.name }}">
                    <svg class="btn-chevron" width="20" height="20" viewBox="0 0 20 20" fill="#DDDDDD"
                      xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M13.5924 8.95103L7.40586 2.4297C6.86234 1.85677 5.96714 1.85677 5.42362 2.4297C4.88011 3.00263 4.88011 3.94629 5.42362 4.51922L10.603 9.99579L5.40764 15.4724C4.86412 16.0453 4.86412 16.9889 5.40764 17.5619C5.6794 17.8483 6.04707 18 6.39876 18C6.75044 18 7.11812 17.8483 7.38988 17.5619L13.5924 11.0405C14.1359 10.4676 14.1359 9.52396 13.5924 8.95103Z" />
                    </svg>
                  </div>
                  <div class="btn-name" fxShow fxHide.lt-md="true">
                    {{ ( partner.name.length>22)? ( partner.name | slice:0:22)+'...':( partner.name) }}
                  </div>
                  <div class="btn-name" fxHide fxShow.lt-md="true">
                    {{ ( partner.name.length>16)? ( partner.name | slice:0:16)+'...':( partner.name) }}
                  </div>
                </button>
              </div>
              <div>
                <button fxLayout="column" type="button" class="btn btn-outline-primary"
                (click)="changeTab(tabs.OWN)" style="cursor: pointer;">
                <div class="btn-img-container" fxFlex="100">
                  <div fxLayout="column" fxLayoutAlign="start start">
                    <span class="fw-b">{{ 'enter.other' | translate }}</span>
                    <span class="fc-6">{{ 'enter.platform' | translate }}</span>
                  </div>
                  <svg class="btn-chevron" width="20" height="20" viewBox="0 0 20 20" fill="#DDDDDD"
                    xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M13.5924 8.95103L7.40586 2.4297C6.86234 1.85677 5.96714 1.85677 5.42362 2.4297C4.88011 3.00263 4.88011 3.94629 5.42362 4.51922L10.603 9.99579L5.40764 15.4724C4.86412 16.0453 4.86412 16.9889 5.40764 17.5619C5.6794 17.8483 6.04707 18 6.39876 18C6.75044 18 7.11812 17.8483 7.38988 17.5619L13.5924 11.0405C14.1359 10.4676 14.1359 9.52396 13.5924 8.95103Z" />
                  </svg>
                </div>
                <div class="btn-name" fxShow fxHide.lt-md="true">
                  {{ 'enter.other' | translate }} {{ 'enter.platform' | translate }}
                </div>
              </button>
              </div>
            </div>

          </mat-tab>
          <mat-tab label="PRÓPRIA">
            <div fxLayout="column" fxLayoutGap="5px" class="form-wrap">
              <div fxLayout="column" fxLayoutGap="5px">
                <div fxLayoutAlign="center" class="text mb-4">
                  {{'enter.text' | translate}}
                </div>
                <div fxLayout="row">
                  <mat-form-field class="enter-input">
                    <input matInput [(ngModel)]="partner" (keyup)="stringToSlug(partner)"
                      placeholder="{{'enter.company' | translate}}" trim (keydown.enter)="continue()" />
                    <mat-hint>{{'enter.hint' | translate}}</mat-hint>
                  </mat-form-field>
                </div>
              </div>
              <div fxLayout="column" class="mt-3">
                <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="30px" fxLayout.lt-sm="column"
                  fxLayoutGap.lt-sm="15px" fxLayoutAlign.lt-sm="center stretch">
                  <div fxFlex="50%" fxFlex.gt-sm="100%">
                    <button class="btn-continue" mat-flat-button color="primary" (click)="continue()" fxFlex>
                      {{'enter.continue' | translate}}
                    </button>
                  </div>
                  <!-- <div class="fs-16 fw-m" fxLayout="row" fxFlex="50%" fxLayoutGap="5px" fxFlex.lt-sm="100%"
                    fxLayoutAlign="center stretch">
                    <a class="text-center register" href="/register" fxFlex>{{'register.register' | translate}}</a>
                  </div> -->
                </div>
                <div *ngIf="invalidPartner" class="mt-4" fxLayout="row" fxLayoutAlign="center center">
                  <mat-error>{{ 'enter.invalidCompany' | translate }}</mat-error>
                </div>
              </div>
            </div>
          </mat-tab>
        </mat-tab-group>


      </div>
    </div>
  </div>


</div>